const key = "convert-window-proxy-response";

const applicable = (resp) => {
	return resp.config.method === "POST" && resp.config.url.match(/api\/forms\/[0-9]*\/proxies\/summary-reports*$/);
};

const modify = (resp) => {
	resp.data.Data = {
		...resp.data.Data,
		Body: {
			...resp.data.Data.Body,
			Action: "IFRAME"
		}	
	};

	return resp;
};

export const convertWindowProxyResponse = [key, applicable, modify];